import { render } from "./IconPicker.vue?vue&type=template&id=11f385a9&scoped=true"
import script from "./IconPicker.vue?vue&type=script&lang=js"
export * from "./IconPicker.vue?vue&type=script&lang=js"

import "./IconPicker.vue?vue&type=style&index=0&id=11f385a9&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f385a9"]])

export default __exports__